import { render, staticRenderFns } from "./confirmarPedido.vue?vue&type=template&id=944023b8&scoped=true"
import script from "./confirmarPedido.vue?vue&type=script&lang=js"
export * from "./confirmarPedido.vue?vue&type=script&lang=js"
import style0 from "./confirmarPedido.vue?vue&type=style&index=0&id=944023b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944023b8",
  null
  
)

export default component.exports